module.exports = __webpack_public_path__ + "img/isr.874270d6.svg";